import React from "react"
import PropTypes from "prop-types"
import Card from "../card"
import Arrow from "../arrow"
import { parameterize } from "../../utils/stringHelpers"
import { Datum, Title, Content, StyledLink, ArrowContainer } from "./styles"
import StatusIconWrapper from "../status-icons/StatusIconWrapper"

const Document = ({ id, name, status, rejectedReason }) => (
  <Card variant="secondary" paddingless>
    <StyledLink to={`/documents/${id}`}>
      <Datum>
        <Title>Name</Title>
        <Content>{name}</Content>
      </Datum>

      <Datum>
        <Title>Status</Title>
        <Content>
          {status}&nbsp;
          <StatusIconWrapper status={parameterize(status, "_")} />
        </Content>
      </Datum>

      {status === "Rejected" && (
        <Datum large>
          <Title>Rejection Reason</Title>
          <Content>{rejectedReason}</Content>
        </Datum>
      )}

      <ArrowContainer>
        <Arrow />
      </ArrowContainer>
    </StyledLink>
  </Card>
)

Document.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  rejectedReason: PropTypes.string
}

export default Document
